export default __webpack_public_path__ + "static/media/armwraps_of_fiendish_invocation.dd6df8b7.jpg";